module.exports = __webpack_public_path__ + "static/media/bottle.8def4027.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameOceanCleanup/bottle.png
// module id = 2551
// module chunks = 0